"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDistance = void 0;
/**
 * Calculates the distance between two points using the Haversine formula
 * @param pos1 First point [lat,lon]
 * @param pos2 Second point [lat,lon]
 * @param options Options for the calculation
 * @default options = {
 *       unit: 'km',
 *       format: false,
 *       exact: false,
 *       formatToFixed: 2,
 *       cutOffForMorePrecision: 0.4
 *   }
 * @returns The distance between the two points as number.
 */
const calculateDistance = (pos1, pos2, options = {
    unit: 'km',
    format: false,
    exact: false,
    formatToFixed: 2,
    cutOffForMorePrecision: 0.4,
}) => {
    const lat1 = pos1[0];
    const lon1 = pos1[1];
    const lat2 = pos2[0];
    const lon2 = pos2[1];
    const rad = Math.PI / 180;
    const dLat = (lat2 - lat1) * rad;
    const dLon = (lon2 - lon1) * rad;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * rad) *
            Math.cos(lat2 * rad) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let dist = 6371 * c;
    switch (options.unit) {
        case 'km':
            break;
        case 'yd':
            dist *= 1093.6133;
            break;
        case 'ft':
            dist *= 3280.8399;
            break;
        case 'mi':
            dist *= 0.621371192;
            break;
        case 'm':
            dist *= 1000;
            break;
        default:
            throw new Error('Invalid unit');
    }
    if (!options.exact)
        dist = Math.round(dist);
    if (options.format) {
        if (options.unit === 'mi' && dist < options.cutOffForMorePrecision) {
            return Math.round(dist * 5280);
        }
        if (options.unit === 'km' && dist < options.cutOffForMorePrecision) {
            return Math.round(dist * 1000);
        }
        dist = parseFloat(dist.toFixed(options.formatToFixed));
        return dist;
    }
    return dist;
};
exports.calculateDistance = calculateDistance;
